var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 330 512"}},_vm.$listeners),[_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M0 0v512h330V0zm300 482H30v-70h270zm0-100H30V90h270zm0-322H30V30h270zM145 447a20 20 0 1120 20 20 20 0 01-20-20z","fill":"currentColor","data-name":"Layer 1"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }